module.exports = __webpack_public_path__ + "assets/img/t12.0bca1bfa.png";